<template>
  <loader v-if="loading" />
  <failed-to-load v-else-if="failed"></failed-to-load>
  <div class="study-list" v-else>
    <template v-if="sortedList.length !== 0">
      <study-card
        v-for="study in sortedList"
        :key="study.id"
        :title="study.title"
        :deadline="study.deadline"
        :id="study.id"
      />
    </template>
    <template v-else>
      No studies yet
    </template>
  </div>
</template>

<script>
import Loader from '@/components/global/Loader.vue';
import FailedToLoad from '@/components/global/FailedToLoad';
import StudyCard from '@/components/art-club/StudyCard';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'StudyList',
  components: { StudyCard, Loader, FailedToLoad },
  data() {
    return {
      loading: false,
      failed: false,
    };
  },
  async created() {
    if (!this.studies) {
      this.loading = true;
      const response = await this.getStudies();

      if (response && response.status >= 300) {
        this.failed = true;
      }

      this.loading = false;
    }
  },
  methods: {
    ...mapActions('studies', ['getStudies']),
  },
  computed: {
    ...mapState({
      token: state => state.auth.jwt.access_token,
      studies: state => state.studies.list,
    }),
    sortedList() {
      if (!this.studies) return null;
      return [...this.studies].sort((x, y) => {
        return x.deadline < y.deadline;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.study-list {
  display: grid;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-columns: auto;

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (min-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
</style>
